"use strict";

var _toConsumableArray = require("/codebuild/output/src3089259882/src/jag-website/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var _toArray = require("/codebuild/output/src3089259882/src/jag-website/node_modules/@babel/runtime/helpers/toArray.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return resolveConfig;
  }
});
var _resolveConfig = /*#__PURE__*/_interopRequireDefault(require("../util/resolveConfig"));
var _getAllConfigs = /*#__PURE__*/_interopRequireDefault(require("../util/getAllConfigs"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function resolveConfig() {
  for (var _len = arguments.length, configs = new Array(_len), _key = 0; _key < _len; _key++) {
    configs[_key] = arguments[_key];
  }
  var _ref = (0, _getAllConfigs.default)(configs[0]),
    _ref2 = _toArray(_ref),
    defaultConfigs = _ref2.slice(1);
  return (0, _resolveConfig.default)([].concat(configs, _toConsumableArray(defaultConfigs)));
}